import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getPatientAnalytic } from "app/services/dashboard/patientAnalyticService";
import { BASE_URL } from "static/constants";

export const patientAnalyticApi = createApi({
  reducerPath: "patientAnalyticApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getPatientAnalytic: builder.query({
      queryFn: ({ account, startDate, endDate }) => {
        return { data: getPatientAnalytic({ account, startDate, endDate }) };
      },
    }),
  }),
});

export const { useGetPatientAnalyticQuery } = patientAnalyticApi;
